module.exports = __webpack_public_path__ + "static/media/Final.9c6c9639.png";